const PREFIX = 'vdr-permissions-update-count';

export function getPermissionsUpdateCountKey(userId: string): string {
  return `${PREFIX}-${userId}`;
}
